import classNames from 'classnames';
import * as React from 'react';
import { CSSProperties } from 'react';
import { Crop, PixelCrop } from 'react-image-crop';

import { ImageCrop } from '../../components/ImageCrop/ImageCrop';
import { Bem } from '../../service/Bem/Bem';
import { Size } from '../../typings/common';
import { getScaledImageSize } from '../CreativeImageCropHelper/CreativeImageCropHelper';

import './CreativeImageCrop.css';

interface CreativeImageCropProps {
    cls?: string;
    src: string;

    crop?: Crop;
    minWidth?: number;
    minHeight?: number;

    onCropComplete: (crop: Crop, pixelCrop: PixelCrop) => void;
    onImageLoaded: (naturalImageSize: Size, imageSize: Size, image: HTMLImageElement) => void;
}

interface CreativeImageCropState {
    imageStyle?: CSSProperties;
}

const BLOCK = 'creative-image-crop';
const DEFAULT_CROP: Crop = {
    x: 0,
    y: 0
};

export class CreativeImageCrop extends React.PureComponent<CreativeImageCropProps, CreativeImageCropState> {
    public state: CreativeImageCropState = {};
    private readonly container: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

    render(): React.ReactNode {
        const { cls, src, crop = DEFAULT_CROP, minWidth, minHeight, onCropComplete } = this.props;
        const { imageStyle } = this.state;

        return (
            <div className={classNames(BLOCK, cls)} ref={this.container}>
                <div className={Bem.cls(BLOCK, 'crop-wrapper')}>
                    <ImageCrop
                        crop={crop}
                        src={src}
                        theme={'dark'}
                        onComplete={onCropComplete}
                        onImageLoaded={this.onImageLoaded}
                        minWidth={minWidth}
                        minHeight={minHeight}
                        imageStyle={imageStyle}
                        crossorigin={'anonymous'}
                        keepSelection={false}
                        emptyCropDisabled={true}
                    />
                </div>
            </div>
        );
    }

    private onImageLoaded = (image: HTMLImageElement): void => {
        const imageSize = {
            width: image.naturalWidth,
            height: image.naturalHeight
        };

        this.props.onImageLoaded(
            imageSize,
            {
                width: image.width,
                height: image.height
            },
            image
        );

        const container = this.container.current;

        if (container) {
            const containerSize = {
                height: container.clientHeight,
                width: container.clientWidth
            };

            if (imageSize.height < containerSize.height) {
                this.setState({
                    imageStyle: getScaledImageSize(imageSize, containerSize)
                });
            }
        }
    };
}
